import PropTypes from "prop-types";
import { CustomContainer } from "../../../DependencyHelper";
import formStyles from "../CreditCheckDetails.module.scss";

const EmploymentDetailsAddLineInfo = ({
  data,
}) => {
  return (
    <CustomContainer className={`${formStyles["form-details-container"]}`}>
      <CustomContainer className="row">
        <CustomContainer className={`${formStyles["pb-6"]} col-md-6 col-sm-12`}>
          <label>Gross monthly salary:</label>
        </CustomContainer>
        <CustomContainer className={`col-md-6 col-sm-12`}>
          <span>{data?.grossMonthlySalary}</span>
        </CustomContainer>
      </CustomContainer>
    </CustomContainer>
  );
};

EmploymentDetailsAddLineInfo.propTypes = {
  data: PropTypes.object
};

EmploymentDetailsAddLineInfo.defaultProps = {
  data: {},
};

export default EmploymentDetailsAddLineInfo;
